/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <transition name="fade">
    <div v-if="visible" class="common-alert-wrapper">
      <b-alert
          :model-value="true"
          :variant="alertVariant"
          dismissible
          class="shadow m-0 d-flex align-items-center bg-white opacity-100 common-alert-box"
          @dismissed="hideAlert"
      >
        <i :class="[iconClass, 'me-2']"></i>

        <div class="overflow-hidden">
          <strong>{{ title }}</strong><br>
          <span
              v-if="description"
              class="small text-truncate d-inline-block"
              style="max-width: 260px;"
          >
            {{ description }}
          </span>
        </div>
      </b-alert>
    </div>
  </transition>
</template>

<script>
import { BAlert } from 'bootstrap-vue-next';

export default {
  name: 'CommonAlert',
  components: {
    BAlert
  },
  props: {
    defaultTimeout: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      visible: false,
      alertVariant: 'success',
      title: '',
      description: '',
      hideTimeout: null
    };
  },
  computed: {
    iconClass() {
      switch (this.alertVariant) {
        case 'success':
          return 'fas fa-check-circle text-success';
        case 'warning':
          return 'fas fa-exclamation-triangle text-warning';
        case 'danger':
          return 'fas fa-times-circle text-danger';
        default:
          return 'fas fa-info-circle text-primary';
      }
    }
  },
  methods: {
    showAlert(variant = 'success', title = '', description = '', timeout = null) {
      this.clearHideTimeout();

      this.alertVariant = variant;
      this.title = title;
      this.description = description;
      this.visible = true;

      const finalTimeout = timeout != null ? timeout : this.defaultTimeout;

      if (finalTimeout > 0) {
        this.hideTimeout = setTimeout(() => {
          this.hideAlert();
        }, finalTimeout);
      }
    },

    showSuccess(title = 'Sukces', description = '', timeout = null) {
      this.showAlert('success', title, description, timeout);
    },

    showWarning(title = 'Uwaga', description = '', timeout = null) {
      this.showAlert('warning', title, description, timeout);
    },

    showDanger(title = 'Błąd', description = '', timeout = null) {
      this.showAlert('danger', title, description, timeout);
    },

    hideAlert() {
      this.clearHideTimeout();
      this.visible = false;
    },

    clearHideTimeout() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    }
  },
  beforeUnmount() {
    this.clearHideTimeout();
  }
};
</script>

<style scoped>
.common-alert-wrapper {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1060;
  max-width: 320px;
}

.common-alert-box {
  border-radius: 10px;
}

/* Transition jak w CommonTable2 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>